import React from 'react';
import AppVars from '../../AppVars.js'
import Logger from '../../Logger.js';
import AccountInactiveView from '../Views/TO/Reset/AccountInactiveView';


let appVars = AppVars.getInstance();

class AccountInactive extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
        }
    }

    resendActivation() {
        // alert("This isn't supported. Check prod if you'd like.");
        window.location.href = "/resend";
    }

    render() {
        return(
            <AccountInactiveView
            email = {this.props.email}
            resendActivation = {this.resendActivation}
            style = {this.props.style}
            />
        )
    }
}

export default AccountInactive;